module.exports = __webpack_public_path__ + "img/52_24.85e02a1e.png";